import { Form, Input, Row } from "antd";
import { MAX_UPC_NUMBER } from "../../../../../../../../../../lib/constants";
import { useEffect, useMemo } from "react";
import { FormInstance, Rule } from "antd/es/form";
import { CloseOutlined } from "@ant-design/icons";

type ToggleUpcNumbersProps = {
  form: FormInstance;
  disabled: boolean;
};

export const ToggleUpcNumbers = ({ form, disabled }: ToggleUpcNumbersProps) => {
  const upcNumbers = Form.useWatch("upcNumbers", form);
  const upcNumberRules: Rule[] = useMemo(() => [{ max: 50, message: MAX_UPC_NUMBER, validateTrigger: "onSubmit" }], []);

  useEffect(() => {
    if (Array.isArray(upcNumbers) && upcNumbers.length === 0) {
      form.setFieldValue("upcNumbers", [""]);
    }
  }, [form, upcNumbers]);

  return (
    <Form.List
      name="upcNumbers"
      rules={[
        {
          validator: async (_, names) => {
            if (names?.length > 5) {
              return Promise.reject(new Error("At most 5 UPC numbers"));
            }
          }
        }
      ]}
    >
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <Form.Item label={index === 0 ? "UPC Number" : ""} required={false} key={field.key}>
              <Row style={{ flexWrap: "nowrap" }}>
                <Form.Item {...field} noStyle rules={upcNumberRules}>
                  <Input placeholder="Enter UPC Number" disabled={disabled} />
                </Form.Item>
                {fields.length > 1 && <CloseOutlined className="ml-2" onClick={() => remove(field.name)} />}
              </Row>
            </Form.Item>
          ))}
          {fields.length < 5 && (
            <p className="my-0 text-sm w-500 logo-cursor card-header" onClick={() => add()}>
              + UPC Number
            </p>
          )}
        </>
      )}
    </Form.List>
  );
};
